// extracted by mini-css-extract-plugin
export var closeButton = "_jb-1";
export var closeX = "_jb-3";
export var container = "_jb-0";
export var image = "_jb-2";